import { DatePipe } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Convenio, Exercicio, ExercicioService, FuncaoService, GlobalService, Login } from 'eddydata-lib';
import { MessageService } from 'primeng/api';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ConvenioPrestacaoService } from '../service/convenio-prestacao.service';

@Component({
  selector: 'app-convenio-prestacao-dlg',
  templateUrl: './convenio-prestacao-dlg.component.html'
})
export class ConvenioPrestacaoDlgComponent implements OnInit, AfterViewInit, OnDestroy {

  protected datepipe: DatePipe;
  public ptBR: any;
  public listaExercicios: Array<any>;
  public exercicio: Exercicio;
  public data_contabilizacao: Date;
  public data_prestacao: Date;
  protected unsubscribe: Subject<void> = new Subject();

  @Input() entidade: Convenio;
  @Input() login: Login;
  @Output() callback: EventEmitter<any[]> = new EventEmitter();

  constructor(
    protected messageService: MessageService,
    private globalService: GlobalService,
    private funcaoService: FuncaoService,
    protected exercicioService: ExercicioService,
    protected prestacaoService: ConvenioPrestacaoService,
  ) { }

  ngOnInit() {
    this.ptBR = this.globalService.obterDataBR();
    this.exercicioService.obterTodosOrdenadoPorAno(this.login.cidade.id).pipe(takeUntil(this.unsubscribe))
      .subscribe((res) => {
        this.listaExercicios = res.content;
      });
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  ngAfterViewInit() {
    this.globalService.calendarMascara();
  }

  public importar() {
    this.prestacaoService.importarPrestacaoConta(this.entidade.id, this.exercicio.id,
      this.login.orgao.id, this.login.usuario.id, this.data_prestacao, this.data_contabilizacao).pipe(takeUntil(this.unsubscribe))
      .subscribe((res) => {
        console.log('chama o callback', res);
        this.callback.emit(res);
      });
  }

  compareFn(c1: any, c2: any): boolean {
    if (c1 && c2) {
      if (c1.id && c2.id) {
        return c1.id === c2.id;
      } else if (c1.chave && c2.chave) {
        return c1.chave == c2.chave;
      } else {
        return c1 === c2;
      }
    } else {
      return false;
    }
  }

}
